import * as React from "react";
const SvgFiRrFloorAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-floor-alt_svg__a)">
      <path
        fill="#062147"
        d="M19.954 8.046a4.48 4.48 0 0 0-4-4C15.723 1.78 13.826 0 11.5 0h-7A4.505 4.505 0 0 0 0 4.5v7c0 2.326 1.78 4.223 4.046 4.454a4.48 4.48 0 0 0 4 4C8.277 22.22 10.174 24 12.5 24h7c2.481 0 4.5-2.019 4.5-4.5v-7c0-2.326-1.78-4.223-4.046-4.454M4.5 14c-.321 0-.626-.066-.909-.177l2.878-2.878 1.648 1.648-1.406 1.406zM2 11.5V9.289l4.25-4.25 1.648 1.648-5.721 5.721A2.5 2.5 0 0 1 2 11.499zm11.823-7.909c.111.282.177.588.177.909v2.211L9.531 11.18 7.883 9.532zM14 9.539V11.5c0 1.378-1.121 2.5-2.5 2.5H9.539zm-1.591-7.362L9.313 5.273 7.665 3.625 9.29 2h2.211c.321 0 .625.066.908.177M4.5 2h1.961L2 6.461V4.5C2 3.122 3.121 2 4.5 2m1.551 14H11.5c2.481 0 4.5-2.019 4.5-4.5V6.051c1.14.232 2 1.242 2 2.449v7c0 1.378-1.121 2.5-2.5 2.5h-7a2.5 2.5 0 0 1-2.449-2M22 19.5c0 1.378-1.121 2.5-2.5 2.5h-7a2.5 2.5 0 0 1-2.449-2H15.5c2.481 0 4.5-2.019 4.5-4.5v-5.449c1.14.232 2 1.242 2 2.449z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-floor-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFloorAlt;
